import {Inject, Injectable, Injector} from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {Observable} from "rxjs";
import {CORE_CONFIG, CoreConfig} from "../../../service/core-config";

type MsProfileType = {
  givenName?: string,
  surname?: string,
  userPrincipalName?: string,
  id?: string
};


@Injectable({providedIn: 'root'})
export class MvsMsGraphService {

  constructor(
    protected injector: Injector,
    private http: HttpClient,
    @Inject(CORE_CONFIG) private coreConfig: CoreConfig) {
  }

  /**
   * Return Profile.
   */
  getProfile(): Observable<any> {
    return this.http.get(this.coreConfig.MS_graph_endpoint);
  }

}
